// extracted by mini-css-extract-plugin
export default {"intput_div":"taglist_intput_div__mLNtE","addlistbtn":"taglist_addlistbtn__dhKoh","cancelbtn":"taglist_cancelbtn__v55ue"};